const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8787';

function buildAuthHeaders(): HeadersInit {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  const token = localStorage.getItem('authToken');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
}

export interface ServerNotification {
  id: string;
  message: string;
  messageType: string;
  channel: string;
  reminderId?: string;
  priority?: number;
  deliveredAt: number;
  metadata?: Record<string, unknown>;
}

export async function fetchServerNotifications(options: {
  limit?: number;
  markAsRead?: boolean;
} = {}): Promise<ServerNotification[]> {
  const params = new URLSearchParams();
  if (options.limit) params.set('limit', String(options.limit));
  if (options.markAsRead === false) params.set('markAsRead', 'false');

  const response = await fetch(
    `${API_BASE_URL}/api/notifications?${params.toString()}`,
    {
      method: 'GET',
      headers: buildAuthHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch notifications (${response.status})`);
  }

  const data = await response.json();
  return data.notifications || [];
}

export async function dismissNotification(id: string): Promise<void> {
  if (!id) return;

  const response = await fetch(`${API_BASE_URL}/api/notifications/dismiss`, {
    method: 'POST',
    headers: buildAuthHeaders(),
    body: JSON.stringify({ id }),
  });

  if (!response.ok) {
    throw new Error(`Failed to dismiss notification (${response.status})`);
  }
}

